import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { CustomToast, UiKit } from 'components';
import { useFetch } from 'utils/hooks';
import { ReactComponent as RefreshIcon } from 'assets/img/alert-icons/refresh-cw.svg';

export default function SyncButton({
  aggregatorId = '',
  isDisabled = false,
  onSynced = () => {}
}) {
  const apiKey = aggregatorId
    ? 'configure.aggregator.sync_carriers'
    : 'configure.carriers.sync';

  const { isLoading: isSyncing, fetchData: onSync } = useFetch(apiKey, {
    loadOnMount: false,
    routeParams: { id: aggregatorId },
    errorMessage: 'Failed sync the carriers. Please try again.',
    onSuccess: data => {
      onSynced(data);
      const added = _get(data, 'added', []);
      const removed = _get(data, 'removed', []);
      const hasDifferences = !_isEmpty(added) || !_isEmpty(removed);
      CustomToast({
        type: hasDifferences ? 'info' : 'success',
        msg: hasDifferences
          ? 'Sync completed and we detected some changes. Please verify your carriers.'
          : 'Sync completed and no new changes are detected.'
      });
    }
  });

  return (
    <UiKit.Button
      size="sm"
      customType="outline"
      onClick={() => !isDisabled && onSync()}
      disabled={isDisabled || isSyncing}
      className={styles.btn}
      data-refresh={isSyncing}
    >
      <RefreshIcon /> {isSyncing ? 'Syncing' : 'Re-Sync'}
    </UiKit.Button>
  );
}
